<template>
	<v-icon :title="type" :small="small" :class="color">{{icon}}</v-icon>
</template>

<script>
import { requestTypes } from "../../enums";

export default {
	props: {
		type: String,
		small: {
			type: Boolean,
			default: false,
		},
		white: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		icon() {
			switch (this.type) {
			case requestTypes.Analysis:
				return "fas fa-heartbeat";
			case requestTypes.Report:
				return "fal fa-analytics";
			case requestTypes.Pkg:
				return "fal fa-box-heart";
			case requestTypes.Snapshot:
				return "fal fa-camera";
			default:
				return "far fa-question";
			}
		},
		color() {
			if (this.white) {
				return "white--text";
			}

			switch (this.type) {
			case requestTypes.Analysis:
				return "indigo--text";
			case requestTypes.Report:
				return "purple--text";
			case requestTypes.Pkg:
				return "pink--text";
			case requestTypes.Snapshot:
				return "orange--text";
			default:
				return "";
			}
		},
	},
};
</script>
